import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import Buttonn from '../pages/Button';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  // const [scrolling, setScrolling] = useState(false); 

  // Function to handle scroll events
  // const handleScroll = () => {
  //   const scrollPosition = window.scrollY; 
  //   if (scrollPosition > 100) { 
  //     setScrolling(true); 
  //   } else {
  //     setScrolling(false); 
  //   }
  // };

  // Add event listener on component mount and clean up on unmount
  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  return (
    // <header className={`header ${scrolling ? 'sticky-header' : ''}`}>
    <header className>
      {/* Header Top */}
   <div className="header-top bgg-darkk py-2">
  <div className="container">
    <div className="row justify-content-center justify-content-xl-between align-items-center">
      
      <div className="col-auto">
        <div className="header-top-contact">
          <ul className="anchor d-md-flex align-items-center mb-0">

            {/* Phone */}
            <li className="px-md-4 fw-bold">
              <a className="text-white" href="tel:+917620911746">
                <i className="fas fa-phone-volume darkcolorrr"></i> +91 7620911746
              </a>
            </li>

            {/* Email */}
            <li className="px-md-4">
              <a className="text-white" href="mailto:booking@skylinecabs.com">
                <i className="far fa-envelope darkcolorrr"></i>
                <span className="text-white fw-bold ms-1"> booking@skylinecabs.com</span>
              </a>
            </li>

            {/* Social Media Icons */}
            <li className="px-md-4 d-flex gap-3">
              <a href="https://www.instagram.com/skyline__cabs/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61586450337721" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>
              <a href="https://x.com/skylinecabs1" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>
              <a href="https://www.linkedin.com/in/skylinecabs-undefined-78b1413b3/?skipRedirect=true" target="_blank" rel="noreferrer">
                <i className="fab fa-linkedin-in text-white"></i>
              </a>
            </li>

          </ul>
        </div>
      </div>

    </div>
  </div>
</div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <img src="/images/logo.jpg" className='logoo' alt="logo" />
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolorr"></i> {/* Mobile Menu Icon */}
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                </NavDropdown>
                {/* <Nav.Link href="/services" className='fw-bold nav-item'>Services</Nav.Link> */}
                <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
                <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>

                <NavDropdown title="Pune &#8652; Mumbai Cab" id="contact-dropdown" className='fw-bold'>
                  {/* <NavDropdown.Item href="/pune-mumbai-cabs" className='fw-bold nav-item'>Pune &#8652; Mumbai Cab</NavDropdown.Item> */}
                  <NavDropdown.Item href="/Pune-to-Mumbai-Cab" className='fw-bold'>Pune to Mumbai Cab</NavDropdown.Item>
                </NavDropdown>

                <NavDropdown title="Mumbai &#8652; Pune Cab" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/Mumbai-to-Pune-Daily-Cab" className='fw-bold '>Mumbai to Pune  Cab </NavDropdown.Item>
                </NavDropdown>

                <Nav.Link href="/booking" className='fw-bold nav-item'>Booking</Nav.Link>
                <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
                <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
                  <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
                </NavDropdown>
                
              </Nav>
              {/* <Buttonn/> */}
            </Navbar.Collapse>
            
          </Container>
         
        </Navbar>
      </div>

      {/* Search Area */}
      {/* {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )} */}
    </header>
  );
};

export default Header;






